import React, {Component} from 'react';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Autocomplete from 'react-autocomplete'
import {Chart} from "react-google-charts";
import {arrayToDataTable} from "../../config/Utils";
import {ChartCardComponent} from "../../v2/components/chartCards/chartCard";
import Aux from 'react-aux'
import {Link} from "react-router-dom";

class Companies extends Component {

    state = {
        value: "",
        searchInitialized: false
    };

    componentDidMount = async () => {
        await this.props.onDrugsCountPerManufacturerFetch();
    };

    componentWillReceiveProps = (newProps) => {
        const drugsCountPerManufacturer = newProps.drugsCountPerManufacturer;
        if (drugsCountPerManufacturer && !this.state.searchInitialized) {
            const topCompany = drugsCountPerManufacturer[0].countryCode;
            this.setState({searchInitialized: true, value: topCompany});
            this.onSelect(topCompany);
        }
    };

    onInputChange = e => {
        this.setState({value: e.target.value});
        this.props.searchByName(e.target.value);
    };

    renderItem = (item, isHighlighted) => {
        let displayName = item;
        if (item.length > 35) {
            displayName = item.substr(0, 35) + "...";
        }
        return (
            <button key={item} className={'dropdown-item w-100'}
               style={{background: isHighlighted ? 'lightgray' : 'white'}}
            >
                {displayName}
            </button>
        )
    };

    onSelect = val => {
        this.setState({value: val});
        this.props.loadStatistics(val);
    };

    onDetailsPress = () => {
        const companyName = this.props.companyStatistics.companyName;
        if (this.props.companyStatistics) {
            this.props.history.push({
                pathname: "/companies/details",
                state: {companyName: companyName},
                search: '?company=' + companyName
            });
        }
    };

    onBubbleClick = (companyIndex) => {
        if (companyIndex != null) {
            const companyName = this.props.drugsCountPerManufacturer[companyIndex].label;
            this.props.history.push({
                pathname: "/companies/details",
                state: {companyName: companyName},
                search: '?company=' + companyName
            });
        }
    };

    renderStatistics = () => {
        if (this.props.loadingCompanyStatistics) {
            return <div className={'d-flex align-items-center justify-content-center'} style={{height: '40vh'}}>
                <CircularProgress size={25}/>
            </div>;
        }
        if (this.props.companyStatistics) {
            let drugsPerAtc = this.props.companyStatistics.drugsCountByATC;
            let chartData;
            if (drugsPerAtc) {
                chartData = arrayToDataTable(drugsPerAtc)
            }
            return (
                <div className={'mt-3'}>
                    <table className="table table-stripped small m-t-md">
                        <tbody>
                        <tr>
                            <td>
                                <i className="fa fa-circle text-navy"/>
                            </td>
                            <td className={'font-weight-bold'}>
                                <span>Total drugs: </span><span>{this.props.companyStatistics.totalDrugs}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-circle text-navy"/>
                            </td>
                            <td className={'font-weight-bold'}>
                                <span>Countries covered: </span><span>{this.props.companyStatistics.totalCountries}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-circle text-navy"/>
                            </td>
                            <td className={'font-weight-bold'}>
                                <span>First drug approved on: </span><span>{this.props.companyStatistics.firstDrugApprovedOn ? this.props.companyStatistics.firstDrugApprovedOn : 'Unknown'}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-circle text-navy"/>
                            </td>
                            <td className={'font-weight-bold'}>
                                <span>First drug approved on: </span><span>{this.props.companyStatistics.firstDrugApprovedOn ? this.props.companyStatistics.firstDrugApprovedOn : 'Unknown'}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    {
                        chartData.length > 0
                            ? <div>
                                <Chart
                                    height={'400px'}
                                    chartType="PieChart"
                                    loader={<CircularProgress/>}
                                    data={chartData}
                                    options={{
                                        title: 'Drugs by ATC',
                                        legend: 'none',
                                        pieHole: '0.3'
                                    }}
                                    rootProps={{'data-testid': '2'}}
                                />
                            </div>
                            : <div style={{minHeight: '400px'}}
                                   className={'d-flex align-items-center justify-content-center flex-column'}>
                                <h3>No data available</h3>
                                <small>Check for more details</small>
                            </div>
                    }
                    <button onClick={this.onDetailsPress}
                            className={'btn btn-success btn-xl font-weight-bold text-uppercase mr-3'}>
                        Details
                    </button>
                    <Link className='btn btn-success btn-outline btn-xl font-weight-bold text-uppercase' to={{
                        pathname: '/companies/details/recently-approved',
                        state: {companyName: this.props.companyStatistics.companyName}
                    }}>Recently approved drugs?</Link>
                </div>
            )
        }
        return null;
    };

    renderRightSide = () => {
        if (!this.props.companyStatistics) {
            return (
                <div>
                    <small>Select a country by clicking on the bar chart or search for one here</small>
                </div>
            )
        }
        return (
            this.renderStatistics()
        )
    };

    render() {
        if (!this.props.drugsCountPerManufacturer) {
            return (
                <div className={'d-flex align-items-center justify-content-center'} style={{minHeight: 65 + 'vh'}}>
                    <CircularProgress/>
                </div>
            )
        }
        return (
            <Aux>
                <div className="row">
                    <div className="col-8">
                        <ChartCardComponent
                            title={'Top 15 drug manufacturers'}
                            subtitle={'Browse for a company for more details where you can compare it with another'}
                            data={arrayToDataTable(this.props.drugsCountPerManufacturer, ['Manufacturer Name', 'Drug Count'])}
                            chartType={'PieChart'}
                            height={'700px'}
                            clicked={(row) => this.onBubbleClick(row)}
                        />
                    </div>
                    <div className={'ibox col-4'}>
                        <div className="ibox-title">
                            <h4>Browse a company</h4>
                            <small className={'d-block'}>Start typing...</small>
                        </div>
                        <div className="ibox-content">
                            <Autocomplete
                                getItemValue={(item) => item}
                                items={this.props.searchResult || []}
                                renderItem={this.renderItem}
                                value={this.state.value}
                                onChange={this.onInputChange}
                                onSelect={this.onSelect}
                                inputProps={{className: 'form-control w-100'}}
                                menuStyle={{
                                    overflow: 'hidden',
                                    width: 100,
                                    display: "block",
                                    zIndex: 10,
                                    position: 'absolute',
                                    left: 0,
                                    top: '100%'
                                }}
                                wrapperStyle={{display: 'block', position: 'relative'}}
                            />
                            {this.renderRightSide()}
                        </div>
                    </div>
                </div>

            </Aux>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onDrugsCountPerManufacturerFetch: () => dispatch(actions.getDrugsCountPerManufacturer()),
        searchByName: (name) => dispatch(actions.searchManufacturersByName(name)),
        loadStatistics: (name) => dispatch(actions.getStatisticsForCompany(name))
    }
};


const mapStateToProps = state => {
    return {
        drugsCountPerManufacturer: state.drugs.drugsCountPerManufacturer,
        searchResult: state.drugs.searchResult,
        companyStatistics: state.drugs.companyStatistics,
        loadingCompanyStatistics: state.drugs.loadingCompanyStatistics
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Companies);
